import React, { useEffect, useState, useRef } from "react";
import axios from "../axiosIn";
import {
  Accordion,
  Input,
  Card,
  Text,
  Message,
  toaster,
  DateInput,
  Button,
  IconButton,
  NumberInput,
  DatePicker,
  SelectPicker,
  Panel,
  Form,
  Carousel,
  Modal,
  List,
  Breadcrumb,
  Textarea,
  Checkbox,
  Drawer,
} from "rsuite";
import { Image } from "react-bootstrap";
import AttachmentIcon from "@rsuite/icons/Attachment";
import { SearchIcon } from "lucide-react";
import { useReactToPrint } from "react-to-print";
import moment from "moment/moment";
import { VscEdit, VscSave } from "react-icons/vsc";
import Table from "react-bootstrap/Table";
import { confApp } from "../CONF_APP";

const { Column, HeaderCell, Cell } = Table;

export const Consulta = (noEspacio) => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [appConfigParams] = useState(
    JSON.parse(localStorage.getItem("auth")).confApp,
  );
  const [idMedico, setIdMedico] = useState(
    JSON.parse(localStorage.getItem("auth")).idMedico,
  );
  const [consultorio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const [medico] = useState(JSON.parse(localStorage.getItem("auth")).medico);

  const [listaSaturaOx] = useState(confApp.VALORES_SATURACION_OX);
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const [nombre, setNombre] = useState(
    JSON.parse(localStorage.getItem("getCita")).nombre,
  );

  const componentRef = useRef();
  const componentValorPreQX = useRef();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check
  const [espacio] = useState(noEspacio);
  const [mostrarModalPreQx, setMostrarModalPreQx] = useState(false);
  const [modalOpenValPreQx, setModalOpenValPreQx] = useState(false);
  const [file, setFile] = useState({});
  const [loaderDatos, setLoaderDatos] = useState(false);
  const [data, setData] = useState([]);
  const [activeKey, setActiveKey] = useState(1);
  const [fecNac, setFecNac] = useState("");
  const [correo, setCorreo] = useState("");
  const [ocupacion, setOcupacion] = useState("");
  const [genero, setGenero] = useState("");
  const [listGeneros] = useState([
    { label: "", value: "" },
    { label: "Femenino", value: "Femenino" },
    { label: "Masculino", value: "Masculino" },
    { label: "Otro", value: "Otro" },
  ]);
  const [fecha] = useState(JSON.parse(localStorage.getItem("getCita")).fecha);
  const [hora] = useState(JSON.parse(localStorage.getItem("getCita")).hora);
  const [defaultExpanded] = useState(true);
  const [disabledAccord2, setDisabledAccord2] = useState(true);
  const [disabledAccord3, setDisabledAccord3] = useState(true);
  const [disabledIni, setDisabledIni] = useState(false);
  const [showNombre, setShowNombre] = useState(false);
  const [showFecNac, setShowFecNac] = useState("");
  const [showCorreo, setShowCorreo] = useState("");
  const [showOcup, setShowOcup] = useState("");
  const [showGenero, setShowGenero] = useState(false);
  const [edad, setEdad] = useState(0);
  const [listaMedicos, setListaMedicos] = useState([]);
  const [listaMedicosLab, setListaMedicosLab] = useState([]);
  const [idMedicoLab, setIdMedicoLab] = useState(0);
  const [listaAnteced, setListaAnteced] = useState([
    { nombre: "", detalles: [] },
  ]);
  const [listaValoraPqx, setListaValoraPqx] = useState([
    { nombre: "", detalles: [] },
  ]);

  const [dataSignos, setdataSignos] = useState([]);
  const [dataSignosEx, setdataSignosEx] = useState([]);

  const [valueGpo1, setValueGpo1] = useState("");
  const [valueGpo2, setValueGpo2] = useState("");
  const [valueGpo3, setValueGpo3] = useState("");
  const [valueGpo4, setValueGpo4] = useState("");

  const [dataNivelEstud] = useState(confApp.NIVEL_ESTUDIO);
  const [nivelEstud, setNivelEstud] = useState("");
  const [religion, setReligion] = useState("");

  const [domicilio, setDomicilio] = useState("");
  const [colonia, setColonia] = useState("");
  const [estado, setEstado] = useState("");
  const [municipio, setMunicipio] = useState("");
  const [listEdoCivil] = useState([
    { label: "", value: "" },
    { label: "Soltero(a)", value: "Soltero(a)" },
    { label: "Casado(a)", value: "Casado(a)" },
    { label: "Divorciado(a)", value: "Divorciado(a)" },
    { label: "Viudo(a)", value: "Viudo(a)" },
    { label: "Union Libre", value: "Union Libre" },
    { label: "Otro", value: "Otro" },
  ]);
  const [edoCivil, setEdoCivil] = useState("");
  const [diagnostico, setDiagnostico] = useState("");
  const [tratamiento, setTratamiento] = useState("");
  const [indicaciones, setIndicaciones] = useState("");

  const [idConsulta, setIdConsulta] = useState(0);
  const [diagnosticoCita, setDiagnosticoCita] = useState("");
  const [tratamientoCita, setTratamientoCita] = useState("");
  const [indicacionesCita, setIndicacionesCita] = useState("");
  const [observaCita, setObservaCita] = useState("");

  const [motivoEx, setMotivoEx] = useState("");
  const [diagnosticoCitaEx, setDiagnosticoCitaEx] = useState("");
  const [tratamientoCitaEx, setTratamientoCitaEx] = useState("");
  const [indicacionesCitaEx, setIndicacionesCitaEx] = useState("");
  const [observaCitaEx, setObservaCitaEx] = useState("");

  const [panelExpandedSignos, setPanelExpandedSignos] = useState(false);

  const [idTipoDoc, setIdTipoDoc] = useState("");
  const [loading, setLoading] = useState(false);
  const [disabledUPload, setDisabledUpload] = useState(true);
  const [observa, setObserva] = useState("");
  const [listServicios, setListServicios] = useState([
    { label: "", value: "" },
  ]);
  const [listCitas, setListCitas] = useState([{ label: "", vlaue: "" }]);
  const [listaExploraFis, setListaExploraFis] = useState([
    { label: "", vlaue: "" },
  ]);
  const [valoresChecked, setValoresChecked] = useState([]);
  const [listaTipoDocs, setListaTipoDocs] = useState([
    { label: "", value: "" },
  ]);
  const [disabledDiag, setDisabledDiag] = useState(true);
  const [disabledTrat, setDisabledTrat] = useState(true);
  const [disabledIndic, setDisabledIndic] = useState(true);
  const [idServicio, setIdServicio] = useState(0);
  const [telefono, setTelefono] = useState(
    JSON.parse(localStorage.getItem("getCita")).telefono,
  );

  const [modalReceta, setModalReceta] = useState(false);
  const [idPaciente, setIdPaciente] = useState(0);

  const [fileList, setFileList] = useState([]);
  const [imageList, setImageList] = useState([{ doc: "", tipoDoc: "" }]);

  const [motivoCons, setMotivoCons] = useState("");
  const [motivoConsEx, setMotivoConsEx] = useState("");
  const [linkDoc, setLinkDoc] = useState("#");

  const [open, setOpen] = useState(false);
  const [tituloDrawer, setTituloDrawer] = useState("");

  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> VARIABLES PARA EXPLORACIÓN FISICA
  const [frecCardiaca, setFrecCardiaca] = useState("");
  const [frecResp, setFrecResp] = useState("");
  const [temp, setTemp] = useState("");
  const [presionArt, setPresioArt] = useState("");
  const [peso, setPeso] = useState("");
  const [talla, setTalla] = useState("");
  const [imc, setImc] = useState("");
  const [saturaOx, setSaturaOx] = useState("");
  const [glicemiaCap, setGlicemiaCap] = useState("");
  const [otrosDatosExplora, setOtrosDatosExplora] = useState("");
  const [labsEstudios, setLabsEstudios] = useState("");
  const [estadoIMC, setEstadoIMC] = useState("");
  const [estadoSaturaOx, setEstadoSaturaOx] = useState("");
  // ------------------------------------------------------------ HISTORICOS DE EXPLORACION ------------------------------
  const [frecCardiacaEx, setFrecCardiacaEx] = useState("");
  const [frecRespEx, setFrecRespEx] = useState("");
  const [tempEx, setTempEx] = useState("");
  const [presionArtEx, setPresioArtEx] = useState("");
  const [pesoEx, setPesoEx] = useState("");
  const [tallaEx, setTallaEx] = useState("");
  const [imcEx, setImcEx] = useState("");
  const [saturaOxEx, setSaturaOxEx] = useState("");
  const [glicemiaCapEx, setGlicemiaCapEx] = useState("");
  const [otrosDatosExploraEx, setOtrosDatosExploraEx] = useState("");
  const [labsEstudiosEx, setLabsEstudiosEx] = useState("");
  const [estadoIMCEx, setEstadoIMCEx] = useState("");
  const [estadoSaturaOxEx, setEstadoSaturaOxEx] = useState("");
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> FIN DE VARIABLES DE EXPLORACION FISICA

  const handleChange = (id, key, value) => {
    const nextData = Object.assign([], data);
    nextData.find((item) => item.id === id)[key] = value;
    setData(nextData);
  };

  const handleEdit = (id) => {
    const nextData = Object.assign([], data);
    const activeItem = nextData.find((item) => item.id === id);

    activeItem.status = activeItem.status ? null : "EDIT";

    setData(nextData);
  };

  const getPaciente = async () => {
    var url = `Consultas/getExistePaciente/${idNegocio}/${telefono}/${nombre}`;

    await axios
      .get(url)
      .then((response) => {
        if (response.data !== "") {
          setIdPaciente(response.data.idPaciente);
          setNombre(response.data.paciente);
          let _fecha = response.data.fechaNac;
          if (_fecha !== null) {
            const _fecNac = new Date(response.data.fechaNac);
            _fecNac.setDate(_fecNac.getDate() + 1);
            console.log(_fecNac);
            setFecNac(_fecNac);
            calculaEdad(response.data.fechaNac);
          } else {
            setFecNac(null);
          }
          setDomicilio(response.data.calleNum);
          setColonia(response.data.colonia);
          setEstado(response.data.estado);
          setMunicipio(response.data.municipio);
          setCorreo(response.data.correo);
          setEdoCivil(response.data.edoCivil);
          setNivelEstud(response.data.nivelEstud);
          setReligion(response.data.religion);

          if (response.data.genero === null) {
            setGenero("");
          } else {
            setGenero(response.data.genero);
          }
          setOcupacion(response.data.ocupacion);

          const dataPaciente = {
            idPaciente: response.data.idPaciente,
          };
          localStorage.setItem("dataPaciente", JSON.stringify(dataPaciente));
        } else {
          setIdPaciente(0);
          setFecNac("");
          setCorreo("");
          setOcupacion("");
          setEdad(0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getExpedAnt = async (idPac) => {
    var url = `Consultas/getExpedAnterior/${idNegocio}/${idPac}`;

    await axios
      .get(url)
      .then((res) => {
        setLinkDoc(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAntecedentes = async (idPac) => {
    var url = `Consultas/getAntecedentes/${idNegocio}/${idPac}`;
    setIdPaciente(idPac);
    await axios
      .get(url)
      .then((response) => {
        setListaAnteced(response.data);
      })
      .then((next) => {
        getServicios(idPac);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getUpdatedAntecedentes = async (idPac) => {
    var url = `Consultas/getAntecedentes/${idNegocio}/${idPac}`;
    setIdPaciente(idPac);
    await axios
      .get(url)
      .then((response) => {
        setListaValoraPqx(response.data);
      })
      .then((next) => {
        setModalOpenValPreQx(mostrarModalPreQx);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getListaCitas = async (idPac) => {
    var url = `Consultas/getListaCitas/${idNegocio}/${idPac}`;

    await axios
      .get(url)
      .then((response) => {
        setListCitas(response.data);
        if (appConfigParams.esLaboratorio === 1) {
          loadMedicosLab(idPac);
        } else {
          loadMedicos(idPac);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getExploraFisicaItems = async () => {
    var url = `Consultas/getItemsExploraFis/${idNegocio}`;

    await axios
      .get(url)
      .then((response) => {
        response.data.forEach((element) => {
          if (element.idGpo === 1) {
            const originalString = element.items;
            setValueGpo1(originalString.join(", "));
          }
          if (element.idGpo === 2) {
            const originalString2 = element.items;
            setValueGpo2(originalString2.join(", "));
          }
          if (element.idGpo === 3) {
            const originalString3 = element.items;
            setValueGpo3(originalString3.join(", "));
          }
          if (element.idGpo === 4) {
            const originalString4 = element.items;
            setValueGpo4(originalString4.join(", "));
          }
        });
        setdataSignos(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getDatosCita = async (fecha, idPac) => {
    var url = `Consultas/getDatosCita/${idNegocio}/${idPac}/${fecha}`;

    await axios
      .get(url)
      .then((response) => {
        setIdConsulta(response.data.idConsulta);
        setMotivoConsEx(response.data.motivoCons);
        setDiagnosticoCitaEx(response.data.diagnostico);
        setTratamientoCitaEx(response.data.tratamiento);
        setIndicacionesCitaEx(response.data.indicaciones);

        // DATOS DE EXPLORACION FISICA
        setFrecCardiacaEx(response.data.dataSignos.frecCardiaca);
        setFrecRespEx(response.data.dataSignos.frecResp);
        setTempEx(response.data.dataSignos.temp);
        setPresioArtEx(response.data.dataSignos.presionArt);
        setPesoEx(response.data.dataSignos.peso);
        setTallaEx(response.data.dataSignos.talla);
        setImcEx(response.data.dataSignos.imc);
        setSaturaOxEx(response.data.dataSignos.saturaOx);
        setGlicemiaCapEx(response.data.dataSignos.glicemiaCap);
        setOtrosDatosExploraEx(response.data.dataSignos.otrosDatosExp);
        setLabsEstudiosEx(response.data.dataSignos.labsEstudios);
        setObservaCitaEx(response.data.anotaciones);
        setdataSignosEx(response.data.dataExplora);
        setMotivoEx(response.data.motivo);
        getDocsCita(response.data.idConsulta);
        const titulo = `Consulta / Fecha: ${fecha}`;
        setTituloDrawer(titulo);
        setOpen(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSetGenero = async (e) => {
    setShowGenero(false);
    setGenero(e);
    setTimeout(() => {
      saveDataField("genero", "");
    }, 500);
  };

  const getDocsCita = async (idConsulta) => {
    var url = `Consultas/getDocsCita/${idNegocio}/${idConsulta}`;

    await axios
      .get(url)
      .then((response) => {
        let doc = [];

        response.data.forEach((element) => {
          doc.push({ doc: element.NombreDoc, tipoDoc: element.tipoDoc });
        });
        setImageList(doc);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const isValidDate = (dateString) => {
    const dateObject = new Date(dateString);
    // Check if the date object is an instance of Date and not an "Invalid Date" (NaN)
    return dateObject instanceof Date && !isNaN(dateObject);
  };

  const loadMedicos = async (idPac) => {
    var url = `Consultas/getMedicos/${idNegocio}`;

    await axios
      .get(url)
      .then((response) => {
        setListaMedicos(response.data);
        if (appConfigParams.mostrarExpedAnt === 1) {
          getExpedAnt(idPac);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const loadMedicosLab = async (idPac) => {
    var url = `Consultas/getMedicosLab/${idNegocio}`;

    await axios
      .get(url)
      .then((response) => {
        setListaMedicosLab(response.data);
        if (appConfigParams.mostrarExpedAnt === 1) {
          getExpedAnt(idPac);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getTipoDocs = async (idPac) => {
    var url = `Consultas/getTipoDoc/${idNegocio}`;

    await axios
      .get(url)
      .then((response) => {
        setListaTipoDocs(response.data);
      })
      .then((nxt) => {
        getListaCitas(idPac);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getServicios = async (idPac) => {
    var url = `Consultas/getServicios/${idNegocio}`;

    await axios
      .get(url)
      .then((response) => {
        setListServicios(response.data);
      })
      .then((next) => {
        getTipoDocs(idPac);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const saveDataField = async (name, goTo) => {
    if (name === "correo") {
      var valid = handleOnChange(correo);
      if (valid === 0) {
        toast("Formato de correo inválido.", "warning");
        return;
      }
    }

    let value = "";
    if (name === "nombre") {
      value = nombre;
    }
    if (name === "correo") {
      value = correo;
    }
    if (name === "ocupacion") {
      value = ocupacion;
    }
    if (name === "fecNac") {
      value = fecNac;
    }
    if (name === "genero") {
      value = genero;
    }

    const data = {
      id: idNegocio,
      idPaciente: idPaciente,
      telefono: telefono,
      campo: name,
      value: value,
    };

    var url = "Consultas/saveFieldDatos";
    await axios
      .post(url, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(async (res) => {
        if (res.data > 0) {
          setIdPaciente(res.data); // GRABAMOS EL ID DEL PACIENTE
          toast("Se actualizó la información de forma correcta.", "info");
          setShowNombre(false);
          setShowCorreo(false);
          setShowFecNac(false);
          setShowOcup(false);
          if (name === "fecNac") {
            getPaciente();
          }
          if (goTo === "Consulta") {
            // GRABAMOS EL ID DEL PACIENTE EN UN LOCAL STORAGE PARA UTILIZARCE EN LOS PRIMEROS ANTECEDENTES
            const dataPaciente = {
              idPaciente: res.data,
            };
            localStorage.setItem("dataPaciente", JSON.stringify(dataPaciente));
            getAntecedentes(res.data);
            handleAccordions(2);
          }
        } else {
          toast(
            "Error al actualizar, valide su conexión a internet",
            "warning",
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const saveDataInit = async () => {
    if (correo) {
      var valid = handleOnChange(correo);
      if (valid === 0) {
        toast("Formato de correo inválido.", "warning");
        return;
      }
    } else {
      setCorreo("");
    }

    const data = {
      id: idNegocio,
      espacio: espacio.noEspacio,
      hora: hora,
      idPaciente: 0,
      nombre: nombre,
      fechaNac: fecNac,
      calleNum: domicilio,
      colonia: colonia,
      telefono: telefono,
      correo: correo,
      ocupacion: ocupacion,
      genero: genero,
      edoCivil: edoCivil,
      estado: estado,
      municipio: municipio,
      nivelEstud: nivelEstud,
      religion: religion,
    };

    var ID = 0;
    var url = "Consultas/saveDatosInit";
    await axios
      .post(url, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(async (res) => {
        if (res.data > 0) {
          ID = res.data;
          await setIdPaciente(res.data);
          toast("Se han guardado todos los datos.", "info");
        } else {
          toast(
            "Ocurrio un error al enviar los datos e iniciar la consulta.",
            "error",
          );
          return;
        }
      })
      .then((next) => {
        if (idMedico === 0) {
          return;
        }

        getAntecedentes(ID);
        handleAccordions(2);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleAccordions = (opc) => {
    switch (opc) {
      case 1:
        setActiveKey(1);
        setDisabledAccord2(true);
        setDisabledAccord3(true);
        setDisabledIni(false);
        break;
      case 2:
        setActiveKey(2);
        setDisabledAccord2(false);
        setDisabledAccord3(false);
        setDisabledIni(true);
        break;
      default:
        break;
    }
  };

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" },
    );
  };

  const handleFecNac = (e) => {
    var esFecha = moment(e, "DD/MM/YYYY").isValid();
    if (esFecha) {
      var fec = new Date(e).toISOString();
      var fecha = moment(fec).format("DD/MM/YYYY");
      setFecNac(fecha);
    }
  };

  const handleOnChange = (email) => {
    // don't remember from where i copied this code, but this works.
    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (re.test(email)) {
      return 1;
    } else {
      return 0;
    }
  };

  const iniciaConsulta = () => {
    saveDataInit();
  };

  const handleTipoDoc = (e) => {
    if (e === null) {
      setIdTipoDoc("");
      setDisabledUpload(true);
    } else {
      setIdTipoDoc(e);
      setDisabledUpload(false);
    }
  };

  const handleServicio = (e) => {
    if (e === null) {
      setIdServicio(0);
      setDisabledDiag(true);
      setDisabledIndic(true);
      setDisabledTrat(true);
    } else {
      setIdServicio(e);
      setDisabledDiag(false);
      setDisabledIndic(false);
      setDisabledTrat(false);
      getExploraFisicaItems();
    }
  };

  const saveObservation = (props) => {
    console.log(
      "ID Anteced: ",
      props.idAnteced,
      " / NoItem: ",
      props.id,
      " Texto: ",
      props.obs,
    );
  };

  const handleListaCitas = (e) => {
    if (e != null) {
      let _fec = e.replace("/", "-");
      _fec = _fec.replace("/", "-");
      console.log("Id Pac: ", idPaciente);
      getDatosCita(_fec, idPaciente);
    } else {
      setDiagnosticoCita("");
      setTratamientoCita("");
      setIndicacionesCita("");
      setObservaCita("");
      setImageList([]);
    }
  };

  const handleFileList = (e) => {
    const file = Array.from(e.target.files);
    setFileList((prevFiles) => [...prevFiles, ...file]);
  };

  const saveConsulta = async () => {
    setLoading(true);
    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append("file", file);
    });

    formData.append("id", idNegocio);
    formData.append("motivo", motivoCons);
    formData.append("fecha", fecha);
    formData.append("hora", hora);
    formData.append("espacio", espacio.noEspacio);
    formData.append("idPaciente", idPaciente);
    formData.append("idMedico", idMedico);
    formData.append("idMedicoLab", idMedicoLab);
    formData.append("idServicio", idServicio);
    formData.append("idTipoDoc", idTipoDoc);
    formData.append("idUser", idUser);
    formData.append("diagnostico", diagnostico);
    formData.append("tratamiento", tratamiento);
    formData.append("indicaciones", indicaciones);
    formData.append("observa", observa);

    formData.append("frecCardiaca", frecCardiaca);
    formData.append("frecResp", frecResp);
    formData.append("temp", temp);
    formData.append("presionArt", presionArt);
    formData.append("peso", peso);
    formData.append("talla", talla);
    formData.append("imc", imc);
    formData.append("saturaOx", saturaOx);
    formData.append("glicemiaCap", glicemiaCap);
    formData.append("otrosDatos", otrosDatosExplora);
    formData.append("labsEstudios", labsEstudios);
    formData.append("datosExploraFis", dataSignos.length);

    if (dataSignos.length > 0) {
      formData.append(dataSignos[0].idGpo, valueGpo1);
      formData.append(dataSignos[1].idGpo, valueGpo2);
      formData.append(dataSignos[2].idGpo, valueGpo3);
      formData.append(dataSignos[3].idGpo, valueGpo4);
    }

    await axios
      .post("Consultas/saveConsulta", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.data > 0) {
          toast("La consulta se ha finalizado", "success");
          if (appConfigParams.emitirReceta === 1) {
            if (mostrarModalPreQx) {
              getAntecedentes(idPaciente);
              getUpdatedAntecedentes(idPaciente);
            } else {
              setModalReceta(true);
            }
          } else {
            setTimeout(() => {
              window.location.reload();
            }, [1200]);
          }
        } else {
          setLoading(false);
          toast("Ocurrio un error al guardar la consulta", "error");
        }
      })
      .catch((error) => {
        setLoading(false);
        toast(
          "Ocurrio un error inesperado, valide su conexión a internet",
          "error",
        );
        console.log(error);
      });
  };

  const getPageMargins = (marginTop, marginRight, marginBottom, marginLeft) => {
    return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important; }`;
  };

  const marginTop = "55mm";
  const marginRight = "25mm";
  const marginBottom = "25mm";
  const marginLeft = "25mm";

  const handlePrint = useReactToPrint({
    documentTitle: "Receta",
    contentRef: componentRef,
    pageStyle: getPageMargins(marginTop, marginRight, marginBottom, marginLeft),
  });

  const getPageMarginsPreQX = (
    marginTop,
    marginRight,
    marginBottom,
    marginLeft,
  ) => {
    return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important; }`;
  };

  const marginTopPreQx = "5mm";
  const marginRightPreQx = "10mm";
  const marginBottomPreQx = "5mm";
  const marginLeftPreQx = "10mm";

  const handlePrintPreQX = useReactToPrint({
    documentTitle: "FormatoPREQX",
    contentRef: componentValorPreQX,
    pageStyle: getPageMarginsPreQX(
      marginTopPreQx,
      marginRightPreQx,
      marginBottomPreQx,
      marginLeftPreQx,
    ),
  });

  const handleClose = () => {
    window.location.reload();
  };

  const handleFechaNac = (e) => {
    var esFecha = moment(e, "DD/MM/YYYY").isValid();
    if (esFecha) {
      var fec = new Date(e).toISOString();
      var fecha = moment(fec).format("DD/MM/YYYY");
      setFecNac(fecha);

      const hoy = new Date(); // Fecha actual
      const fechaNac = new Date(e); // Fecha de nacimiento del input

      let edad = hoy.getFullYear() - fechaNac.getFullYear(); // Diferencia de años inicial

      const mesActual = hoy.getMonth();
      const mesNac = fechaNac.getMonth();

      // Si el mes actual es menor que el mes de nacimiento, no ha cumplido años
      if (mesActual < mesNac) {
        edad--;
      } else if (mesActual === mesNac) {
        // Si los meses son iguales, revisamos el día
        const diaActual = hoy.getDate();
        const diaNac = fechaNac.getDate();
        if (diaActual < diaNac) {
          edad--; // No ha cumplido años aún en el mes actual
        }
      }

      // Para obtener meses y días exactos (más complejo, pero posible)
      // Se puede calcular la diferencia en milisegundos y convertir, o iterar meses/días
      // El método anterior solo da los años cumplidos.
      setEdad(edad);
    }
  };

  const getFinalText = (text) => {
    const lines = text.split("\n");
    return (
      <div>
        {lines.map((item, index) => (
          <React.Fragment key={index}>
            {item}
            {index < lines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </div>
    );
  };

  const calculaEdad = (e) => {
    const hoy = new Date(); // Fecha actual
    const fechaNac = new Date(e); // Fecha de nacimiento del input

    let edad = hoy.getFullYear() - fechaNac.getFullYear(); // Diferencia de años inicial

    const mesActual = hoy.getMonth();
    const mesNac = fechaNac.getMonth();

    // Si el mes actual es menor que el mes de nacimiento, no ha cumplido años
    if (mesActual < mesNac) {
      edad--;
    } else if (mesActual === mesNac) {
      // Si los meses son iguales, revisamos el día
      const diaActual = hoy.getDate();
      const diaNac = fechaNac.getDate();
      if (diaActual < diaNac) {
        edad--; // No ha cumplido años aún en el mes actual
      }
    }

    // Para obtener meses y días exactos (más complejo, pero posible)
    // Se puede calcular la diferencia en milisegundos y convertir, o iterar meses/días
    // El método anterior solo da los años cumplidos.
    setEdad(edad);
  };

  const handleLoadFile = (e) => {
    console.log(e.target.files);
    if (e.target.files.length > 0) {
      setFile(e.target.files);
      saveDocument(e.target.files);
    }
  };

  const calculaIMC = async () => {
    setImc("");
    if (peso > 0 && talla > 0) {
      const resultImc = peso / ((talla / 100) * (talla / 100));
      setImc(resultImc.toFixed(1));
      var url = `Consultas/getEstadoIMC/${resultImc.toFixed(1)}`;
      await axios
        .get(url)
        .then((response) => {
          setEstadoIMC(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const calculaSaturaOx = (valor) => {
    setSaturaOx(valor);
    let result = "";
    if (valor > 99) setEstadoSaturaOx("Requiere atención");
    else {
      if (valor > 0) {
        listaSaturaOx.forEach(function (x) {
          if (x.valorMin <= valor && x.valorMax >= valor) {
            result = x.estado;
          }
        });
        setEstadoSaturaOx(result);
      } else {
        setEstadoSaturaOx("");
      }
    }
  };

  const expandeSignosExplora = () => {
    setPanelExpandedSignos(true);
  };

  const handleChangeValueExplora = (e, idGpo) => {
    if (idGpo === 1) {
      setValueGpo1(e);
    }
    if (idGpo === 2) {
      setValueGpo2(e);
    }
    if (idGpo === 3) {
      setValueGpo3(e);
    }
    if (idGpo === 4) {
      setValueGpo4(e);
    }
  };

  const handleChangecheckPreQx = (value, checked) => {
    // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ESTAS LINEAS SOLO OCUPARAN PARA CUANDO SE REQUIERA REVISAR EL FORMATO <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
    // getUpdatedAntecedentes(idPaciente);
    // setModalOpenValPreQx(true);
    setMostrarModalPreQx(checked);
  };

  const saveDocument = async (f) => {
    var url = "saveDoc";
    const formData = new FormData();
    formData.append("id", idNegocio);
    formData.append("idPaciente", idPaciente);
    formData.append("file", f[0]);
    formData.append("idUser", idUser);
    formData.append("expedAnt", 1);

    await axios
      .post("Consultas/saveDoc", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.data !== "") {
          toast("El documento se ha cargado de forma correcta", "success");
          setLinkDoc(res.data);
        } else {
          toast("Ocurrio un error al subir el documento", "error");
          setLinkDoc("#");
        }
      })
      .catch((error) => {
        toast(
          "Ocurrio un error inesperado, valide su conexión a internet",
          "error",
        );
        console.log(error);
      });
  };

  const openWindowFrame = () => {
    const urlToEmbed = `/Docs/Negocios/${idNegocio}/${idPaciente}/${linkDoc}`; // PDF
    const windowFeatures = "width=1200,height=900,resizable=yes,scrollbars=yes";
    const newWindow = window.open("", "_blank", windowFeatures);

    if (newWindow) {
      newWindow.document.open();
      newWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <style>
              iframe {
                      width: 98vw;  /* 100% of the viewport width */
                      height: 98vh; /* 100% of the viewport height */
                      border: none;  /* Removes default border */
                      display: block;
                  }
            <style>
            <head>
                <title>Visor PDF</title>
                <style>body { margin: 0; padding: 0; }</style>
            </head>
            <body>
                <iframe src="${urlToEmbed}" width="100%" height="100%" frameborder="0"></iframe>
            </body>
            </html>
        `);
      newWindow.document.close();
    }
  };

  const handleCellChange = async (props) => {
    var url = "Consultas/saveItem";
    const idNegocio = JSON.parse(localStorage.getItem("auth")).id;

    const data = {
      opc: props.opc,
      id: idNegocio,
      idPaciente: idPaciente,
      idAnteced: props.idAnteced,
      noItem: props.id,
      valorado: props.opc === "resp" ? props.valor : "",
      obs: props.opc === "resp" ? "" : props.texto,
    };

    await axios
      .post(url, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(async (res) => {
        toast("Se ha registrado la información.", "success");
      })
      .catch((error) => {
        toast("Ocurrio un error al guardar.", "error");
      });
  };

  const handleChangeSignos = (e, campo) => {
    const valor = e;
    // La expresión regular /^\d*$/ permite solo dígitos (0-9)
    if (valor === "" || /^\d+$/.test(valor)) {
      if (campo === "gl") {
        setGlicemiaCap(valor);
      }
      if (campo === "fc") {
        setFrecCardiaca(valor);
      }
      if (campo === "fr") {
        setFrecResp(valor);
      }
      if (campo === "sp") {
        setSaturaOx(valor);
      }
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update on resize
    };
    getPaciente();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageList]);

  return (
    <div
      style={{
        backgroundColor: "white",
        padding: "10px",
        borderRadius: "15px",
      }}
    >
      <Accordion activeKey={activeKey} bordered onSelect={setActiveKey}>
        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ACORDION DE LOS DATOS GENERALES */}
        <Accordion.Panel
          header={`Datos Generales`}
          defaultExpanded={defaultExpanded}
          bordered
          eventKey={1}
        >
          <Card bordered style={{ padding: "10px" }}>
            <div className="row">
              <div className="col-lg-3 col-md-3 col-sm-3">
                <b>Nombre completo</b>
                <Input value={nombre} onChange={(e) => setNombre(e)} />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <b>Fecha de nacimiento</b>
                <DateInput
                  format="dd/MM/yyyy"
                  id="fecNac"
                  name="fecNac"
                  value={fecNac}
                  defaultValue={fecNac}
                  onChange={(e) => handleFechaNac(e)}
                />
              </div>
              <div className="col-lg-1 col-md-1 col-sm-1">
                <b>Edad</b>
                <Input readOnly value={edad} style={{ textAlign: "center" }} />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <b>Teléfono</b>
                <NumberInput
                  controls={false}
                  id="telefono"
                  maxLength={10}
                  min={0}
                  value={telefono}
                  onChange={(e) => setTelefono(e)}
                />
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4">
                <b>Correo</b>
                <Input
                  value={correo}
                  name="correo"
                  onChange={(e) => setCorreo(e)}
                />
              </div>
            </div>
            <br></br>
            <div className="row">
              <div className="col">
                <Panel
                  bordered
                  header="Domicilio"
                  defaultExpanded
                  key="panelDomicilio"
                >
                  <div className="row">
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <b>Calle y número</b>
                      <Input
                        value={domicilio}
                        onChange={(e) => setDomicilio(e)}
                      />
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <b>Colonia</b>
                      <Input value={colonia} onChange={(e) => setColonia(e)} />
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <b>Estado</b>
                      <Input value={estado} onChange={(e) => setEstado(e)} />
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <b>Municipio</b>
                      <Input
                        value={municipio}
                        onChange={(e) => setMunicipio(e)}
                      />
                    </div>
                  </div>
                </Panel>
              </div>
            </div>
            <br></br>
            <div className="row">
              <div className="col-lg-2 col-md-2 col-sm-2">
                <b>Estado Civil</b>
                <SelectPicker
                  searchable={false}
                  data={listEdoCivil}
                  value={edoCivil}
                  placeholder="Selecciona"
                  onChange={(e) => setEdoCivil(e)}
                  style={{ width: "auto" }}
                  block
                ></SelectPicker>
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <b>Genero</b>
                <SelectPicker
                  block
                  searchable={false}
                  data={listGeneros}
                  value={genero}
                  placeholder="Selecciona"
                  onChange={(e) => setGenero(e)}
                ></SelectPicker>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3">
                <b>Ocupación</b>
                <Input value={ocupacion} onChange={(e) => setOcupacion(e)} />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <b>Nivel Estudios</b>
                <SelectPicker
                  searchable={false}
                  data={dataNivelEstud}
                  value={nivelEstud}
                  placeholder="Selecciona"
                  onChange={(e) => setNivelEstud(e)}
                  style={{ width: "auto" }}
                  block
                ></SelectPicker>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3">
                <b>Religión</b>
                <Input value={religion} onChange={(e) => setReligion(e)} />
              </div>
            </div>
          </Card>
          <br></br>
          <Button
            block
            appearance="primary"
            onClick={() => iniciaConsulta()}
            disabled={disabledIni}
            loading={loading}
          >
            {idMedico === 1 ? "Guardar y continuar..." : "Guardar datos"}
          </Button>
        </Accordion.Panel>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> REGISTRO ANTERIOR DE HISTORIA CLINICA  <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        {appConfigParams.mostrarExpedAnt === 1 ? (
          <Accordion.Panel
            header="Registro anterior de Historia Clínica"
            key="Reg_Ant_HS"
            bordered
            disabled={disabledAccord2}
            eventKey={6}
          >
            <div className="row">
              <div
                className="col-lg-3 col-md-3 col-sm-3"
                style={{ padding: "10px" }}
              >
                <Text>Cargar documento...</Text>
                <input
                  className="form-control"
                  type="file"
                  id="fileHS"
                  accept=".pdf"
                  onChange={(e) => handleLoadFile(e)}
                  multiple
                />
              </div>
              <div
                className="text-left col-lg-9 col-md-9 col-sm-9"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {linkDoc === "" ? (
                  "Sin archivo..."
                ) : (
                  <Button appearance="link" onClick={() => openWindowFrame()}>
                    <AttachmentIcon size={25} />
                    &nbsp; {linkDoc}
                  </Button>
                )}
              </div>
            </div>
          </Accordion.Panel>
        ) : (
          ""
        )}
        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> HISTORIA CLINICA <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Accordion.Panel
          header={`${appConfigParams.esLaboratorio == 1 ? "Generales" : "Historia Clínica"}`}
          key="HistoriaClinica"
          bordered
          disabled={disabledAccord2}
          defaultExpanded={false}
          eventKey={2}
        >
          {listaAnteced.length > 0
            ? listaAnteced.map((itm, index) => {
                return (
                  <div key={`div-${index}`}>
                    <Accordion.Panel
                      header={`${itm.nombre}`}
                      bordered
                      disabled={disabledAccord2}
                      defaultExpanded={false}
                      eventKey={2}
                      key={`accord-${index}`}
                    >
                      <Table
                        striped
                        bordered
                        hover
                        responsive
                        key={`tbl-${index}`}
                        style={{
                          width: "100%",
                          cellPadding: "5",
                          cellSpacing: "10",
                          fontSize: isMobile ? "10px" : "16px",
                        }}
                        cellPadding={10}
                        cellSpacing={10}
                      >
                        <thead key={`headers-${index}`}>
                          <tr
                            key={`fila-${index}`}
                            style={{
                              borderBottom: "solid 2px",
                              paddingBottom: "15",
                            }}
                          >
                            {isMobile ? (
                              ""
                            ) : (
                              <th
                                key={`header0-${index}`}
                                style={{ textAlign: "center", width: "5%" }}
                              >
                                <b>#</b>
                              </th>
                            )}
                            <th
                              key={`header1-${index}`}
                              style={{ width: "30%" }}
                            >
                              <b>Item</b>
                            </th>
                            <th
                              key={`header2-${index}`}
                              style={{ width: "15%", textAlign: "center" }}
                            >
                              <b>Respuesta</b>
                            </th>
                            <th
                              key={`header3-${index}`}
                              style={{ width: "50%" }}
                            >
                              <b>Observaciones</b>
                            </th>
                          </tr>
                        </thead>
                        {itm.detalles.map((item, ix) => {
                          return (
                            <tr key={`fila-${ix}`}>
                              {isMobile ? (
                                ""
                              ) : (
                                <td
                                  key={`celda1-${ix}`}
                                  style={{ textAlign: "center" }}
                                >
                                  {item.id}
                                </td>
                              )}
                              <td key={`celda2${index}-${ix}`}>{item.Item}</td>
                              <td style={{ textAlign: "center" }}>
                                <select
                                  key={`select-${ix}`}
                                  style={{ border: "none" }}
                                  onChange={(e) =>
                                    handleCellChange({
                                      opc: "resp",
                                      idAnteced: item.idAnteced,
                                      id: item.id,
                                      valor: e.target.value,
                                    })
                                  }
                                >
                                  <option
                                    key={`opt-select-SinVal-${ix}-${index}`}
                                    value=""
                                    selected={
                                      item.valorado === "" ? true : false
                                    }
                                  ></option>
                                  <option
                                    key={`opt-select-SI-${ix}-${index}`}
                                    value="SI"
                                    selected={
                                      item.valorado === "SI" ? true : false
                                    }
                                  >
                                    SI
                                  </option>
                                  <option
                                    key={`opt-select-NO-${ix}-${index}`}
                                    value="NO"
                                    selected={
                                      item.valorado === "NO" ? true : false
                                    }
                                  >
                                    NO
                                  </option>
                                </select>
                              </td>
                              <td key={`obs-${index}${ix}`}>
                                <Textarea
                                  autosize
                                  defaultValue={item.observacion}
                                  style={{
                                    fontSize: isMobile ? "10px" : "16px",
                                  }}
                                  onBlur={(e) =>
                                    handleCellChange({
                                      opc: "obs",
                                      idAnteced: item.idAnteced,
                                      id: item.id,
                                      texto: e.target.value,
                                    })
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </Table>
                    </Accordion.Panel>
                  </div>
                );
              })
            : ""}
        </Accordion.Panel>

        {/* ************************************************************************** BLOQUE DE INICIO DE LA CONSULTA ************************************************** */}
        <Accordion.Panel
          header={`${appConfigParams.esLaboratorio === 1 ? "Laboratorio" : "Consulta"}`}
          key="Consulta"
          bordered
          disabled={disabledAccord2}
          eventKey={3}
        >
          <Form>
            <Card shaded>
              <Card.Header as="h3">
                <div className="row mb-2">
                  <div className="col-lg-5 col-md-5 col-sm-5">
                    <SelectPicker
                      searchable={true}
                      data={listCitas}
                      style={{ width: "100%" }}
                      block
                      placeholder="Registro de citas anteriores"
                      onChange={(e) => handleListaCitas(e)}
                    ></SelectPicker>
                  </div>
                </div>
                <div className="row mb-1">
                  <div className="col-lg-5 col-md-5 cols-m-5">
                    <Textarea
                      rows={3}
                      maxLength={500}
                      placeholder="Motivo de la consulta"
                      value={motivoCons}
                      onChange={(e) => setMotivoCons(e)}
                    />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-3">
                    {appConfigParams.esLaboratorio === 1 ? (
                      <SelectPicker
                        searchable={false}
                        data={listaMedicosLab}
                        style={{ width: "100%" }}
                        block
                        placeholder="Selecciona al médico"
                        onChange={(e) => setIdMedicoLab(e)}
                      ></SelectPicker>
                    ) : (
                      <SelectPicker
                        searchable={false}
                        data={listaMedicos}
                        style={{ width: "100%" }}
                        value={idMedico}
                        block
                        placeholder="Selecciona al usuario"
                        onChange={(e) => setIdMedico(e)}
                      ></SelectPicker>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <SelectPicker
                      searchable={false}
                      data={listServicios}
                      style={{ width: "100%" }}
                      block
                      placeholder="Selecciona el servicio"
                      onChange={(e) => handleServicio(e)}
                    ></SelectPicker>
                  </div>
                </div>

                {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> SIGNOS VITALES Y EXPLORACIÓN FISICA <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
                {appConfigParams.mostrarExplora === 1 ? (
                  <div className="row mb-1">
                    <div className="col">
                      <Panel
                        bordered
                        header="Signos Vitales y Exploración Física"
                        expanded={true}
                        key="panelSignosVitales"
                        onClick={expandeSignosExplora}
                      >
                        <div className="row mb-2">
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">Peso</Text>
                            <NumberInput
                              controls={false}
                              style={{ textAlign: "center" }}
                              value={peso}
                              onChange={(e) => setPeso(e)}
                            />
                            <span style={{ fontSize: "12px" }}>
                              En kilogramos
                            </span>
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">Talla</Text>
                            <NumberInput
                              controls={false}
                              style={{ textAlign: "center" }}
                              value={talla}
                              onChange={(e) => setTalla(e)}
                            />
                            <span style={{ fontSize: "12px" }}>
                              En centimetros
                            </span>
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">IMC</Text>
                            <NumberInput
                              controls={false}
                              style={{ textAlign: "center" }}
                              value={imc}
                              onChange={(e) => setImc(e)}
                              onFocus={calculaIMC}
                            />
                            <span style={{ fontSize: "12px", color: "blue" }}>
                              {estadoIMC}
                            </span>
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm" title="Presión arterial">
                              TA
                            </Text>
                            <Input
                              style={{ textAlign: "center" }}
                              value={presionArt}
                              onChange={(e) => setPresioArt(e)}
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">FC</Text>
                            <NumberInput
                              controls={false}
                              style={{ textAlign: "center" }}
                              value={frecCardiaca}
                              onChange={(e) => handleChangeSignos(e, "fc")}
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">FR</Text>
                            <NumberInput
                              controls={false}
                              style={{ textAlign: "center" }}
                              value={frecResp}
                              onChange={(e) => handleChangeSignos(e, "fr")}
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">
                              <b>T</b>emperatura
                            </Text>
                            <NumberInput
                              controls={false}
                              style={{ textAlign: "center" }}
                              value={temp}
                              onChange={(e) => setTemp(e)}
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">
                              Sp<b>O</b>2
                            </Text>
                            <NumberInput
                              controls={false}
                              style={{ textAlign: "center" }}
                              value={saturaOx}
                              onChange={(e) => handleChangeSignos(e, "sp")}
                            />
                            <span style={{ fontSize: "12px", color: "blue" }}>
                              {estadoSaturaOx}
                            </span>
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">Glicemia capilar</Text>
                            <NumberInput
                              controls={false}
                              style={{
                                textAlign: "center",
                                alignItems: "center",
                                alignContent: "center",
                              }}
                              value={glicemiaCap}
                              onChange={(e) => handleChangeSignos(e, "gl")}
                            />
                            <span style={{ fontSize: "12px" }}>mg/dl.</span>
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Text size="sm">Otros datos</Text>
                            <Input
                              as="textarea"
                              placeholder="Generales de la exploración..."
                              rows={3}
                              value={otrosDatosExplora}
                              onChange={(e) => setOtrosDatosExplora(e)}
                            />
                          </div>
                        </div>
                        {dataSignos.length > 0 ? (
                          <div className="row">
                            <div className="col-lg-3 col-md-3 col-sm-3">
                              <Card key={`card1`}>
                                <Card.Header
                                  style={{ fontSize: "12px" }}
                                  key={`cardHeader-1`}
                                >
                                  {dataSignos[0].nombre}
                                </Card.Header>
                                <Card.Body key={`cardBody-1`}>
                                  <Textarea
                                    key={`gpo1`}
                                    rows={4}
                                    value={valueGpo1}
                                    onChange={(e) =>
                                      handleChangeValueExplora(
                                        e,
                                        dataSignos[0].idGpo,
                                      )
                                    }
                                  />
                                </Card.Body>
                              </Card>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-3">
                              <Card key={`card2`}>
                                <Card.Header
                                  style={{ fontSize: "12px" }}
                                  key={`cardHeader-2`}
                                >
                                  {dataSignos[1].nombre}
                                </Card.Header>
                                <Card.Body key={`cardBody-2`}>
                                  <Textarea
                                    key={`gpo2`}
                                    rows={4}
                                    value={valueGpo2}
                                    onChange={(e) =>
                                      handleChangeValueExplora(
                                        e,
                                        dataSignos[1].idGpo,
                                      )
                                    }
                                  />
                                </Card.Body>
                              </Card>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-3">
                              <Card key={`card-3`}>
                                <Card.Header
                                  style={{ fontSize: "12px" }}
                                  key={`cardHeader-3`}
                                >
                                  {dataSignos[2].nombre}
                                </Card.Header>
                                <Card.Body key={`cardBody-3`}>
                                  <Textarea
                                    key={`gpo3`}
                                    rows={4}
                                    value={valueGpo3}
                                    onChange={(e) =>
                                      handleChangeValueExplora(
                                        e,
                                        dataSignos[2].idGpo,
                                      )
                                    }
                                  />
                                </Card.Body>
                              </Card>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-3">
                              <Card key={`card-4`}>
                                <Card.Header
                                  style={{ fontSize: "12px" }}
                                  key={`cardHeader-4`}
                                >
                                  {dataSignos[3].nombre}
                                </Card.Header>
                                <Card.Body key={`cardBody-4`}>
                                  <Textarea
                                    key={`gpo4`}
                                    rows={4}
                                    value={valueGpo4}
                                    onChange={(e) =>
                                      handleChangeValueExplora(
                                        e,
                                        dataSignos[3].idGpo,
                                      )
                                    }
                                  />
                                </Card.Body>
                              </Card>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </Panel>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> LABORATORIOS Y/O ESTUDIOS DE GABINETE */}
                <div className="row">
                  <div className="col">
                    <Panel
                      bordered
                      header="Laboratorios y/o Estudios de Gabinete"
                      defaultExpanded
                      key="panelLabsEstud"
                    >
                      <div className="row mb-2">
                        <div className="col">
                          <Input
                            as="textarea"
                            style={{ width: "100%" }}
                            rows={3}
                            placeholder="Escriba aquí los resultados de los laboratorio o estudios..."
                            value={labsEstudios}
                            onChange={(e) => setLabsEstudios(e)}
                          />
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-lg-2 col-md-2 cols-sm-2">
                          <input
                            className="form-control-sm"
                            type="file"
                            id="file"
                            onChange={(e) => handleFileList(e)}
                            multiple
                          />
                        </div>
                        <div
                          className="col-lg-10 col-md-10 col-sm-10"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {fileList.length > 0 && (
                            <Breadcrumb size="lg">
                              {fileList.map((file, index) => (
                                <Breadcrumb.Item key={index}>
                                  {file.name}
                                </Breadcrumb.Item>
                              ))}
                            </Breadcrumb>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <Input
                            as="textarea"
                            rows={3}
                            placeholder="Anotaciones..."
                            value={observa}
                            onChange={(e) => setObserva(e)}
                          />
                        </div>
                      </div>
                    </Panel>
                  </div>
                </div>
              </Card.Header>

              <Card.Body>
                {appConfigParams.esLaboratorio === 1 ? (
                  ""
                ) : (
                  <>
                    <div className="row">
                      <div className="col-lg-4 col-md-4 col-sm-4">
                        <Panel
                          header="Diagnostico"
                          collapsible
                          bordered
                          disabled={disabledDiag}
                          defaultExpanded
                          key="panelDianostico"
                        >
                          <Input
                            as="textarea"
                            rows={4}
                            placeholder="Escriba el diagnostico"
                            onChange={(e) => setDiagnostico(e)}
                          />
                        </Panel>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-4">
                        <Panel
                          header="Tratamiento"
                          collapsible
                          bordered
                          defaultExpanded
                          disabled={disabledTrat}
                          key="panelTrat"
                        >
                          <Input
                            as="textarea"
                            rows={4}
                            placeholder="Escriba el tratamiento"
                            onChange={(e) => setTratamiento(e)}
                          />
                        </Panel>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-4">
                        <Panel
                          header="Indicaciones (Receta Médica)"
                          collapsible
                          bordered
                          defaultExpanded
                          disabled={disabledIndic}
                          key="panelIndicaciones"
                        >
                          <Input
                            as="textarea"
                            rows={4}
                            defaultExpanded
                            placeholder="Escriba las indicaciones"
                            onChange={(e) => setIndicaciones(e)}
                          />
                        </Panel>
                      </div>
                    </div>
                    <br></br>
                  </>
                )}

                {appConfigParams.mostrarFmtPreQx > 0 ? (
                  <div className="row">
                    <div
                      className="text-center col"
                      style={{
                        height: "35px",
                        lineHeight: "normal",
                        paddingTop: "0",
                      }}
                    >
                      <Checkbox onChange={handleChangecheckPreQx}>
                        Imprimir formato de <b>VALORACIÓN PRE QX</b>
                      </Checkbox>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="row">
                  <div className="col">
                    <Button
                      appearance="primary"
                      block
                      disabled={disabledDiag}
                      loading={loading}
                      onClick={() => saveConsulta()}
                    >
                      Guardar
                    </Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Form>
        </Accordion.Panel>
        <br></br>
        <br></br>
      </Accordion>

      {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> DRAWER EXPEDIENTE PACIENTE */}
      <Drawer size="xxl" open={open} onClose={() => setOpen(false)}>
        <Drawer.Header>
          <Drawer.Title>
            {nombre} <br /> {tituloDrawer}
          </Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          <Card>
            <Card.Body>
              <Text size={"md"} weight="bold">
                Motivo de consulta
              </Text>
              {motivoEx}
            </Card.Body>
          </Card>
          {appConfigParams.mostrarExplora === 1 ? (
            <div className="row mb-1">
              <div className="col">
                <Panel
                  bordered
                  header="Exploración Física"
                  defaultExpanded
                  key="panelExploraFisExpedinete"
                >
                  <div className="row">
                    <div className="text-center col-lg-1 col-md-1 col-sm-1">
                      <Text size="sm">Peso</Text>
                      <Input
                        style={{ textAlign: "center" }}
                        value={pesoEx}
                        readOnly
                      />
                    </div>
                    <div className="text-center col-lg-1 col-md-1 col-sm-1">
                      <Text size="sm">Talla</Text>
                      <Input
                        style={{ textAlign: "center" }}
                        value={tallaEx}
                        readOnly
                      />
                    </div>
                    <div className="text-center col-lg-1 col-md-1 col-sm-1">
                      <Text size="sm">IMC</Text>
                      <Input
                        style={{ textAlign: "center" }}
                        value={imcEx}
                        readOnly
                      />
                    </div>
                    <div className="text-center col-lg-1 col-md-1 col-sm-1">
                      <Text size="sm" title="Presión arterial">
                        TA
                      </Text>
                      <Input
                        style={{ textAlign: "center" }}
                        value={presionArtEx}
                        readOnly
                      />
                    </div>
                    <div className="text-center col-lg-1 col-md-1 col-sm-1">
                      <Text size="sm" title="Frec. Cardiaca">
                        FC
                      </Text>
                      <Input
                        style={{ textAlign: "center" }}
                        value={frecCardiacaEx}
                        readOnly
                      />
                    </div>
                    <div className="text-center col-lg-1 col-md-1 col-sm-1">
                      <Text size="sm" title="Frec. Respiratoria">
                        FR
                      </Text>
                      <Input
                        style={{ textAlign: "center" }}
                        value={frecRespEx}
                        readOnly
                      />
                    </div>
                    <div className="text-center col-lg-1 col-md-1 col-sm-1">
                      <Text size="sm" title="Temperatura">
                        <b>T</b>emperatura
                      </Text>
                      <Input
                        style={{ textAlign: "center" }}
                        value={tempEx}
                        readOnly
                      />
                    </div>
                    <div className="text-center col-lg-1 col-md-1 col-sm-1">
                      <Text size="sm" title="Saturación de O2">
                        Sp<b>O</b>2
                      </Text>
                      <Input
                        style={{ textAlign: "center" }}
                        value={saturaOxEx}
                        readOnly
                      />
                    </div>
                    <div className="text-center col-lg-1 col-md-1 col-sm-1">
                      <Text size="sm">Glicemia capilar</Text>
                      <Input
                        style={{ textAlign: "center" }}
                        value={glicemiaCapEx}
                        readOnly
                      />
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <Text size="sm">Otros datos</Text>
                      <Input
                        as="textarea"
                        placeholder="Generales de la exploración..."
                        rows={3}
                        value={otrosDatosExploraEx}
                        readOnly
                      />
                    </div>
                  </div>
                </Panel>
              </div>
            </div>
          ) : (
            ""
          )}
          {dataSignosEx.length > 0 ? (
            <div className="row mb-2">
              <div className="col-lg-3 col-md-3 col-sm-3">
                <Card key={`card1-Ex`}>
                  <Card.Header
                    style={{ fontSize: "12px" }}
                    key={`cardHeader-1-Ex`}
                  >
                    <b>{dataSignosEx[0].nombre}</b>
                  </Card.Header>
                  <Card.Body key={`cardBody-1-Ex`}>
                    <Textarea
                      key={`gpo1-Ex`}
                      rows={4}
                      readOnly
                      value={dataSignosEx[0].items[0]}
                      onChange={(e) =>
                        handleChangeValueExplora(e, dataSignosEx[0].idGpo)
                      }
                    />
                  </Card.Body>
                </Card>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3">
                <Card key={`card2-Ex`}>
                  <Card.Header
                    style={{ fontSize: "12px" }}
                    key={`cardHeader-2-Ex`}
                  >
                    <b>{dataSignosEx[1].nombre}</b>
                  </Card.Header>
                  <Card.Body key={`cardBody-2-Ex`}>
                    <Textarea
                      key={`gpo2-Ex`}
                      rows={4}
                      readOnly
                      value={dataSignosEx[1].items[0]}
                      onChange={(e) =>
                        handleChangeValueExplora(e, dataSignosEx[1].idGpo)
                      }
                    />
                  </Card.Body>
                </Card>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3">
                <Card key={`card-3-Ex`}>
                  <Card.Header
                    style={{ fontSize: "12px" }}
                    key={`cardHeader-3-Ex`}
                  >
                    <b>{dataSignosEx[2].nombre}</b>
                  </Card.Header>
                  <Card.Body key={`cardBody-3-Ex`}>
                    <Textarea
                      key={`gpo3-Ex`}
                      rows={4}
                      readOnly
                      value={dataSignosEx[2].items[0]}
                      onChange={(e) =>
                        handleChangeValueExplora(e, dataSignosEx[2].idGpo)
                      }
                    />
                  </Card.Body>
                </Card>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3">
                <Card key={`card-4-Ex`}>
                  <Card.Header
                    style={{ fontSize: "12px" }}
                    key={`cardHeader-4-Ex`}
                  >
                    <b>{dataSignosEx[3].nombre}</b>
                  </Card.Header>
                  <Card.Body key={`cardBody-4-Ex`}>
                    <Textarea
                      key={`gpo4-Ex`}
                      rows={4}
                      readOnly
                      value={dataSignosEx[3].items[0]}
                      onChange={(e) =>
                        handleChangeValueExplora(e, dataSignosEx[3].idGpo)
                      }
                    />
                  </Card.Body>
                </Card>
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="row mb-2">
            <div className="col">
              <List style={{ flex: 1 }} bordered>
                <List.Item>
                  <b>Diagnostico</b>
                  <br></br> {diagnosticoCitaEx}
                </List.Item>
                <List.Item>
                  <b>Tratamiento</b>
                  <br></br> {tratamientoCitaEx}
                </List.Item>
                <List.Item>
                  {appConfigParams.emitirReceta === 1 ? (
                    <IconButton
                      size="sm"
                      circle
                      onClick={() => setModalReceta(true)}
                      placement="left"
                      icon={<SearchIcon />}
                      appearance="ghost"
                    ></IconButton>
                  ) : (
                    ""
                  )}
                  &nbsp;
                  <b>Indicaciones</b>
                  <br></br>
                  {getFinalText(indicacionesCitaEx)}
                </List.Item>
              </List>
            </div>
          </div>
          <Panel header="Laboratorios y/o Estudios de Gabinete" bordered>
            <div className="row mb-3">
              <div className="col">
                <Input
                  as="textarea"
                  style={{ width: "100%" }}
                  rows={2}
                  placeholder="Escriba aquí los resultados de los laboratorio o estudios..."
                  value={labsEstudiosEx}
                  readOnly
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-4">
                {imageList.length > 0 ? (
                  <Carousel
                    autoplay
                    autoplayInterval={4000}
                    shape="bar"
                    height={120}
                  >
                    {imageList.map((el, index) => {
                      if (el.tipoDoc === "File") {
                        return (
                          <div key={index}>
                            <br></br>
                            <ul>
                              <a
                                style={{ color: "white" }}
                                href={`Images/Negocios/${idNegocio}/Expedientes/${idPaciente}/Consultas/${idConsulta}/${el.doc}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {el.doc}
                              </a>
                            </ul>
                          </div>
                        );
                      } else {
                        return (
                          <div key={index}>
                            <a
                              style={{ color: "white" }}
                              href={`Images/Negocios/${idNegocio}/Expedientes/${idPaciente}/Consultas/${idConsulta}/${el.doc}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {el.doc}
                              {/* <img
                                height="200"
                                alt="Doc o Imagen"
                                src={`Images/Negocios/${idNegocio}/Expedientes/${idPaciente}/Consultas/${idConsulta}/${el.doc}`}
                              ></img> */}
                            </a>
                          </div>
                        );
                      }
                    })}
                  </Carousel>
                ) : (
                  ""
                )}
              </div>
              <div className="col-lg-8 col-lg-md-8 col-sm-8">
                <b>Notas</b>
                <Input
                  as="textarea"
                  rows={3}
                  placeholder="Anotaciones..."
                  readOnly
                  value={observaCita}
                />
              </div>
            </div>
          </Panel>
        </Drawer.Body>
      </Drawer>

      {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL PARA RECETA MEDICA */}
      <Modal
        size="lg"
        open={modalReceta}
        onClose={handleClose}
        keyboard={false}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>Indicaciones (Receta Médica)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <hr></hr>
          <Panel>
            <div ref={componentRef}>
              <div className="row">
                <div className="col">
                  <table style={{ width: "100%" }} border={0}>
                    <tr>
                      <td style={{ width: "50%" }}>{diagnostico}</td>
                      <td>{getFinalText(indicaciones)}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </Panel>
          <hr></hr>
        </Modal.Body>
        <Modal.Footer>
          <Button appearance="primary" onClick={handlePrint}>
            Imprimir
          </Button>
          <Button onClick={handleClose} appearance="ghost">
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL PARA FOTMATO DE VALORACION PRE QX */}
      <Modal
        size="full"
        key="modalPreQX"
        open={modalOpenValPreQx}
        onClose={handleClose}
        keyboard={false}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>FORMATO DE VALORACIÓN PRE QX</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div ref={componentValorPreQX}>
            <hr></hr>
            <div className="row">
              <div className="col">
                <table style={{ width: "100%", border: "0" }} border={0}>
                  <tr>
                    <td rowSpan={4}>
                      <Image
                        src={`Images/Negocios/${idNegocio}/LogoPreQX.jpg`}
                        style={{ height: 120, margin: 10 }}
                      />
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <h3>{`${consultorio.Estado} a ${new Date().toLocaleString("es-MX", { timeZone: "UTC", dateStyle: "long" })}`}</h3>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right" }}>
                      <h4>VALORACIÓN PRE QX {medico.titulo}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right" }}>
                      <b>FICHA DE IDENTIFICACIÓN</b>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right", fontSize: "14px" }}>
                      {`${nombre}, ${genero} de ${edad} años, ${fecNac}, ${edoCivil}, ${religion}, ${nivelEstud}, ${ocupacion}`}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <hr></hr>
            <br></br>
            <div className="row mb-4">
              <div className="col">
                <table style={{ width: "100%", border: "0" }} border={0}>
                  {listaValoraPqx.length > 0 ? (
                    <>
                      <tr>
                        <td style={{ textAlign: "center", fontSize: "14px" }}>
                          <b>ANTECEDENTES HEREDO-FAMILIARES:</b>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontSize: "14px" }}>
                          {listaValoraPqx[0].detalles.length > 0
                            ? listaValoraPqx[0].detalles
                                .map(
                                  (item) =>
                                    item.Item +
                                    " " +
                                    item.valorado +
                                    " " +
                                    item.observacion,
                                )
                                .join(", ")
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <td>&nbsp;</td>
                      </tr>
                      <tr>
                        <td style={{ textAlign: "center", fontSize: "14px" }}>
                          <b>ANTECEDENTES PERSONALES NO PATOLOGICOS:</b>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontSize: "14px" }}>
                          {listaValoraPqx[0].detalles.length > 0
                            ? listaValoraPqx[1].detalles
                                .map(
                                  (item) =>
                                    item.Item +
                                    " " +
                                    item.valorado +
                                    " " +
                                    item.observacion,
                                )
                                .join(", ")
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <td>&nbsp;</td>
                      </tr>
                      <tr>
                        <td style={{ textAlign: "center", fontSize: "14px" }}>
                          <b>ANTECEDENTES PERSONALES PATOLOGICOS:</b>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontSize: "14px" }}>
                          {listaValoraPqx[0].detalles.length > 1
                            ? listaValoraPqx[2].detalles
                                .map(
                                  (item) =>
                                    item.Item +
                                    " " +
                                    item.valorado +
                                    " " +
                                    item.observacion,
                                )
                                .join(", ")
                            : ""}
                        </td>
                      </tr>
                    </>
                  ) : (
                    ""
                  )}
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "14px", textAlign: "center" }}>
                      <b>PADECIMIENTO ACTÚAL:</b>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "14px" }}>{motivoCons}</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "14px", textAlign: "center" }}>
                      <b>EXPLORACIÓN FÍSICA:</b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{ fontSize: "14px" }}
                    >{`Signos Vitales: PESO ${peso}, TA ${presionArt}, FC ${frecCardiaca}, FR ${frecResp}, T ${temp}, 
                    SAT ${saturaOx}, ${valueGpo1}, ${valueGpo2}, ${valueGpo3}, ${valueGpo4}.`}</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "14px", textAlign: "center" }}>
                      <b>PARACLINICOS:</b>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "14px" }}>{labsEstudios}</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "14px", textAlign: "center" }}>
                      <b>DIAGNOSTICO:</b>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "14px" }}>● {diagnostico}</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "14px", textAlign: "center" }}>
                      <b>PLAN:</b>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "14px" }}>
                      {getFinalText(tratamiento)}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <br></br>
            <br></br>
            <br></br>
            <div className="row">
              <div className="text-center col">
                A T E N T A M E N T E <br></br>
                {medico.medico}
                <br></br>
                {medico.titulo}
                <br></br>
                CEDULA PROFESIONAL {medico.cedula1}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button appearance="primary" onClick={handlePrintPreQX}>
            Imprimir
          </Button>
          <Button onClick={handleClose} appearance="ghost">
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
      <br></br>
      <br></br>
    </div>
  );
};

function toValueString(value, dataType) {
  return dataType === "date" ? value?.toLocaleDateString() : value;
}

const fieldMap = {
  string: Input,
  number: NumberInput,
  date: DatePicker,
  select: SelectPicker,
};

const EditableCell = ({
  key,
  rowData,
  dataType,
  dataKey,
  onChange,
  onEdit,
  ...props
}) => {
  const editing = rowData.status === "EDIT";

  const Field = fieldMap[dataType];
  const value = rowData[dataKey];
  const text = toValueString(value, dataType);
  const _key = key;

  return (
    <Cell
      {...props}
      className={editing ? "table-cell-editing" : ""}
      onDoubleClick={() => {
        onEdit?.(rowData.id);
      }}
    >
      {editing ? (
        <Field
          key={_key}
          defaultValue={value}
          searchable={false}
          data={[
            { label: "SI", value: "SI" },
            { label: "NO", value: "NO" },
          ]}
          onChange={(value) => {
            onChange?.(rowData.id, dataKey, value);
          }}
          style={{ height: "30px", width: "99%" }}
        />
      ) : (
        text
      )}
    </Cell>
  );
};

const saveObs = async (id, rowData, estatus) => {
  if (estatus === undefined) {
    return;
  }
  var url = "Consultas/saveItem";
  const idNegocio = JSON.parse(localStorage.getItem("auth")).id;
  const idPaciente = JSON.parse(
    localStorage.getItem("dataPaciente"),
  ).idPaciente;

  const data = {
    id: idNegocio,
    idPaciente: idPaciente,
    idAnteced: rowData.idAnteced,
    noItem: rowData.id,
    valorado: rowData.valorado,
    obs: rowData.observacion,
  };

  await axios
    .post(url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(async (res) => {
      console.log(res);
    })
    .catch((error) => {
      console.log(error);
    });
};

const ActionCell = ({
  key,
  rowData,
  dataKey,
  onEdit,
  onSave,
  onRemove,
  ...props
}) => {
  return (
    <Cell {...props} style={{ padding: "6px", display: "flex", gap: "4px" }}>
      <IconButton
        key={props.key}
        appearance="subtle"
        icon={rowData.status === "EDIT" ? <VscSave /> : <VscEdit />}
        onClick={() => {
          saveObs(rowData.id, rowData, rowData.status);
          onEdit(rowData.id);
        }}
      />
    </Cell>
  );
};
